var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18754 8.5415V7.56249C6.18754 4.90464 8.34214 2.75 11 2.75C13.6579 2.75 15.8125 4.90464 15.8125 7.56249V8.5415C17.0637 9.08758 17.8732 10.3223 17.875 11.6875V15.8125C17.8728 17.71 16.3351 19.2477 14.4375 19.25H7.56255C5.66502 19.2477 4.12732 17.71 4.12504 15.8125V11.6875C4.12681 10.3223 4.93631 9.08758 6.18754 8.5415ZM10.3125 14.4375C10.3125 14.8172 10.6203 15.125 11 15.125C11.3797 15.125 11.6875 14.8172 11.6875 14.4375V13.0625C11.6875 12.6828 11.3797 12.375 11 12.375C10.6203 12.375 10.3125 12.6828 10.3125 13.0625V14.4375ZM7.56252 8.25001H14.4375V7.56252C14.4375 5.66405 12.8985 4.12501 11 4.12501C9.10153 4.12501 7.56252 5.66402 7.56252 7.56252V8.25001Z",
    fill: "#FFB531"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.2f967bf12642ae57b76b3bc7eaa6b5bb.svg";
export { ForwardRef as ReactComponent };